import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { 
    Card, 
    CardHeader, 
    CardBody, 
    Row, 
    Col, 
    Button, 
    Label, 
    Spinner // Added Spinner
} from "reactstrap";

import ProjectContext from '../../ProjectContext';

import featuresService from '../../services/api/features-service';

import GrievancePermissionsListing from './GrievancePermissionsListing'; 
import '../connectedtv/ctv.css'; 

const GrievancePermissions = (props) => {
    const history = useHistory();
    const projectDetails = useContext(ProjectContext);

    const [showLoader, setShowLoader] = useState(true);
    const [isGrievanceEnabled, setIsGrievanceEnabled] = useState(false);

    const projectId = projectDetails ? projectDetails.id : '';

    useEffect(() => {
        (async () => {
            if (projectId) {
                try {
                    const featureStatus = await featuresService.getFeatureStatus('enable_grievance_management', projectId);
                    if (featureStatus.status && featureStatus.data) {
                        setIsGrievanceEnabled(featureStatus.data.enable_grievance_management);
                    }
                } catch (error) {
                    console.log("Error fetching feature status:", error);
                } finally {
                    setShowLoader(false);
                }
            } else {
                setShowLoader(false);
            }
        })();
    }, [projectId]);

    // 3. Standard Safety Checks
    if (!projectDetails || projectDetails.id === '') {
        history.push("/project/allprojects");
    }

    // Ensure URL has project param (good practice for deep linking)
    let getProjectSlug = new URLSearchParams(props.location.search).get('project');
    if (!getProjectSlug) {
        history.push({
            search: '?project=' + projectDetails.slug
        })
    }

    // 4. Render
    
    // Loading State
    if (showLoader) {
        return (
            <div className="container mt-30 text-center">
                <Spinner color="primary" />
            </div>
        );
    }

    // Enabled State
    if (isGrievanceEnabled) {
        return <GrievancePermissionsListing {...props} />;
    } 
    
    // Disabled State (Book Demo)
    else {
        return (
            <div className="container mt-30">
                <Card>
                    <CardHeader>
                        <Row>
                            <Col><Label className="ctvHeading"><b>Contact Us: helpdesk@sortd.mobi</b></Label></Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <div className="ctvInfo">
                            <Row><Col><h2>Sortd Grievance Management</h2></Col></Row>
                            <Row><Col md="7">Now Manage, track, and resolve public grievances through one single platform.</Col></Row>
                            <Row><Col md="7">Book a Demo now.</Col></Row>
                            <Row>
                                <Col>
                                    <Button type="button" className="btnBlue btn btn-secondary" onClick={(event) => {
                                        window.open('https://mail.google.com/mail/?view=cm&fs=1&to=helpdesk@sortd.mobi&su=Enquiry for Sortd Grievance Management', '_blank');
                                        event.preventDefault();
                                    }}>Book Now</Button>
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default GrievancePermissions;